<template>
    <layout-internal-container>
        <div class="flex flex-col md:flex-row justify-between w-full items-start md:items-end gap-4">
            <div class="flex flex-col gap-2">
                <span class="text-sm text-light font-medium">
                    Here's all your availability mentoring
                </span>
            </div>
        </div>

        <a-table
            class="ant-table-striped" 
            :columns="columns" 
            :data-source="availabilities"
            :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
            bordered
        >
        </a-table>
    </layout-internal-container>
</template>
  
<script setup>
import { ref, onMounted } from 'vue';
import moment from 'moment';
import axios from "@/plugins/axios";

const availabilities = ref([]);

const columns = [
    {
        title: 'Program',
        dataIndex: 'program',
        key: 'program',
        ellipsis: true,
    },
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        width: 300,
    },
    {
        title: 'Time Slot',
        dataIndex: 'timeslot',
        key: 'timeslot',
        width: 200,
    },
];

const formatTime = (time) => {
    return moment(time, 'HH:mm:ss').format('HH:mm');
}

onMounted(() => {
    fetchAvailability();
})

const fetchAvailability = async () => {
    try {
        const response = await axios.get(`/mentor/availability`);
        
        availabilities.value = response.data.data.map((item, index) => ({
            key: item.id,
            program: item.program,
            date: item.date,
            timeslot: item.time_slot || ''
        }));
    } catch (error) {
        console.error(error);
    }
}
</script>
  